import React, { useState } from "react";

const InterviewDoctorOrthoA2 = ({ onClose, shareUrl, shareTitle, shareText }) => {
  const [showShareMenu, setShowShareMenu] = useState(false);

  const handleShareClick = (platform) => {
    const url = shareUrl || window.location.href;
    const title = shareTitle || "Interview with Orthopedic Surgeon";
    const text = shareText || "Check out this interview with Dr. Rao about orthopedic health!";

    if (platform === "webshare" && navigator.share) {
      navigator.share({ title, text, url }).catch(() => {});
    } else if (platform === "whatsapp") {
      window.open(`https://wa.me/?text=${encodeURIComponent(text + " " + url)}`);
    } else if (platform === "facebook") {
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`);
    } else if (platform === "twitter") {
      window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`);
    } else if (platform === "telegram") {
      window.open(`https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`);
    } else if (platform === "email") {
      window.location.href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(text + "\n\n" + url)}`;
    } else if (platform === "copy") {
      navigator.clipboard?.writeText(url).then(() => {
        alert("Link copied to clipboard!");
      }).catch(() => {
        const textarea = document.createElement("textarea");
        textarea.value = url;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        alert("Link copied to clipboard!");
      });
    }
    setShowShareMenu(false);
  };


  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.35)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        overflowY: 'auto',
        paddingTop: '20px',
        paddingBottom: '20px',
      }}
      onClick={onClose}
    >
      <div
        style={{
          ...styles.container,
          maxWidth: '700px',
          margin: 'auto',
          position: 'relative',
          padding: 24,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          style={{
            position: 'absolute',
            top: 12,
            right: 12,
            background: 'none',
            border: 'none',
            fontSize: 24,
            color: '#1976d2',
            cursor: 'pointer',
            padding: 0,
            width: 36,
            height: 36,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          title="Close"
        >
          ✕
        </button>

        <h1 style={{ color: '#1976d2', fontSize: '1.1rem', marginTop: 0, marginBottom: 16 }}>
          Interview with Orthopedic Surgeon
        </h1>

        <p style={{ ...styles.question, fontSize: '0.80rem' }}>
          <strong>Interviewer:</strong> Dr. Rao, thank you so much for joining us
          today! Orthopedic issues seem to be getting more common these days. What
          do you treat most often?
        </p>
        <p style={{ ...styles.answer, fontSize: '0.80rem' }}>
          <strong>Dr. Rao:</strong> Thanks for having me! Yes, orthopedic problems
          are definitely on the rise. I mostly see knee and shoulder pain, lower
          back issues, arthritis, ligament injuries, and fractures. With more
          people hitting the gym, sports injuries have become very common too.
        </p>

        <p style={{ ...styles.question, fontSize: '0.80rem' }}>
          <strong>Interviewer:</strong> What usually causes these joint pains and
          injuries?
        </p>
        <p style={{ ...styles.answer, fontSize: '0.80rem' }}>
          <strong>Dr. Rao:</strong> A mix of things—poor posture, sedentary
          lifestyle, being overweight, improper exercise form, and natural wear &
          tear. Younger people often get injured from sudden intense workouts,
          while older adults suffer more from arthritis.
        </p>

        <p style={{ ...styles.question, fontSize: '0.80rem' }}>
          <strong>Interviewer:</strong> What symptoms should someone NOT ignore?
        </p>
        <p style={{ ...styles.answer, fontSize: '0.80rem' }}>
          <strong>Dr. Rao:</strong> Persistent pain, swelling, clicking or locking
          of joints, difficulty walking, numbness or tingling, or being unable to
          bear weight after an injury. These should never be ignored.
        </p>

        <p style={{ ...styles.question, fontSize: '0.80rem' }}>
          <strong>Interviewer:</strong> Many people say "It'll go away on its
          own." Is that true?
        </p>
        <p style={{ ...styles.answer, fontSize: '0.80rem' }}>
          <strong>Dr. Rao:</strong> Minor strains may improve, but recurring or
          worsening pain is your body signalling for help. The body whispers
          before it screams—catching problems early helps avoid long-term issues.
        </p>

        <p style={{ ...styles.question, fontSize: '0.80rem' }}>
          <strong>Interviewer:</strong> What lifestyle habits help keep bones and
          joints healthy?
        </p>
        <p style={{ ...styles.answer, fontSize: '0.80rem' }}>
          <strong>Dr. Rao:</strong> Stay active, maintain good posture, control
          weight, eat a protein- and calcium-rich diet, and avoid sitting for long
          hours. Moving your body regularly is the best gift you can give your
          joints.
        </p>

        <p style={{ ...styles.question, fontSize: '0.80rem' }}>
          <strong>Interviewer:</strong> People struggle a lot with posture. Any
          easy fixes?
        </p>
        <p style={{ ...styles.answer, fontSize: '0.80rem' }}>
          <strong>Dr. Rao:</strong> Sure! Keep screens at eye level, use chairs
          with back support, avoid slouching, stand evenly on both feet, and
          stretch your neck and back every hour. Small corrections make a huge
          difference.
        </p>

        <p style={{ ...styles.question, fontSize: '0.80rem' }}>
          <strong>Interviewer:</strong> Gym injuries are common. How can people
          avoid them?
        </p>
        <p style={{ ...styles.answer, fontSize: '0.80rem' }}>
          <strong>Dr. Rao:</strong> Start slow, learn correct form, warm up and
          cool down, and never rush into heavy weights. Don't compare yourself to
          others. If something hurts sharply—stop immediately.
        </p>

        <p style={{ ...styles.question, fontSize: '0.80rem' }}>
          <strong>Interviewer:</strong> How can someone protect their joints as
          they age?
        </p>
        <p style={{ ...styles.answer, fontSize: '0.80rem' }}>
          <strong>Dr. Rao:</strong> Stay active with walking, yoga, or swimming.
          Strength training supports joints. And don't skip your Vitamin D and
          calcium—most people are deficient without knowing it.
        </p>

        <p style={{ ...styles.question, fontSize: '0.80rem' }}>
          <strong>Interviewer:</strong> When should someone visit an orthopedic
          specialist?
        </p>
        <p style={{ ...styles.answer, fontSize: '0.80rem' }}>
          <strong>Dr. Rao:</strong> If pain affects daily life, sleep, or
          mobility, it's time for a check-up. After any injury with swelling,
          instability, or difficulty moving—don't delay.
        </p>

        <p style={{ ...styles.question, fontSize: '0.80rem' }}>
          <strong>Interviewer:</strong> Final message for everyone?
        </p>
        <p style={{ ...styles.answer, fontSize: '0.80rem' }}>
          <strong>Dr. Rao:</strong> Your joints are made for movement—so keep
          moving! A little exercise today can prevent a lifetime of pain.
        </p>

        <div style={{ marginTop: 20, paddingTop: 16, borderTop: '1px solid #eee', fontSize: '0.85rem', color: '#999' }}>
          <p style={{ margin: 0 }}>Dr. Singh is a leading orthopedic surgeon with 15 years of experience in joint reconstruction, age related ortho issues, and regenerative medicine.</p>
        </div>

        <div style={{ marginTop: 20, paddingTop: 16, borderTop: '1px solid #ddd', display: 'flex', gap: '1rem', alignItems: 'center', position: 'relative' }}>
          <div style={{ position: 'relative' }}>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowShareMenu(!showShareMenu);
              }}
              style={{
                background: '#1976d2',
                color: '#fff',
                border: 'none',
                padding: '8px 12px',
                borderRadius: 4,
                cursor: 'pointer',
                fontSize: '0.75rem',
                minWidth: 'auto',
                display: 'flex',
                alignItems: 'center',
                gap: 6,
              }}
              title="Share"
            >
              <span style={{ lineHeight: 1 }}>Share</span>
              <span style={{ fontSize: '0.8rem', opacity: 0.9 }}>▾</span>
            </button>

            {showShareMenu && (
              <div
                style={{
                  position: 'absolute',
                  bottom: '100%',
                  left: 0,
                  background: '#fff',
                  border: '1px solid #ddd',
                  borderRadius: 4,
                  boxShadow: '0 -2px 8px rgba(0,0,0,0.15)',
                  marginBottom: 8,
                  minWidth: 140,
                  zIndex: 10,
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  onClick={() => handleShareClick('whatsapp')}
                  style={{
                    display: 'block',
                    width: '100%',
                    background: 'none',
                    border: 'none',
                    padding: '8px 12px',
                    textAlign: 'left',
                    cursor: 'pointer',
                    fontSize: '0.75rem',
                    borderBottom: '1px solid #eee',
                    color: '#25D366',
                    fontWeight: 500,
                  }}
                >
                  WhatsApp
                </button>
                <button
                  onClick={() => handleShareClick('email')}
                  style={{
                    display: 'block',
                    width: '100%',
                    background: 'none',
                    border: 'none',
                    padding: '8px 12px',
                    textAlign: 'left',
                    cursor: 'pointer',
                    fontSize: '0.75rem',
                    borderBottom: '1px solid #eee',
                    color: '#333',
                  }}
                >
                  Email
                </button>
                <button
                  onClick={() => handleShareClick('copy')}
                  style={{
                    display: 'block',
                    width: '100%',
                    background: 'none',
                    border: 'none',
                    padding: '8px 12px',
                    textAlign: 'left',
                    cursor: 'pointer',
                    fontSize: '0.75rem',
                    color: '#333',
                  }}
                >
                  Copy Link
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "850px",
    margin: "40px auto",
    padding: "30px",
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    boxShadow: "0 0 15px rgba(0,0,0,0.1)",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.6",
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "25px",
    color: "#2c3e50",
  },
  question: {
    fontSize: "18px",
    fontWeight: "600",
    marginTop: "20px",
  },
  answer: {
    fontSize: "17px",
    marginTop: "10px",
  },
};

export default InterviewDoctorOrthoA2;
